import { render, staticRenderFns } from "./StatusPassos.vue?vue&type=template&id=17e9e3c3&lang=html&"
import script from "./StatusPassos.vue?vue&type=script&lang=js&"
export * from "./StatusPassos.vue?vue&type=script&lang=js&"
import style0 from "./StatusPassos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/workflow/StatusPassos.vue
// module id = 57
// module chunks = 28